import { Injectable } from "@angular/core";
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthenticationService } from "../login/authentication/authentication.service";
import { environment } from "src/environments/environment";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private readonly authenticationService: AuthenticationService) { }
    /**
     *
     *
     * @param {HttpRequest<any>} request
     * @param {HttpHandler} next
     * @returns {Observable<HttpEvent<any>>}
     * @memberof JwtInterceptor
     */
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const currentUser = this.authenticationService.currentUserValue;
        if (!currentUser) {
            return next.handle(request);
        }
        const url = request.url;
        if (
            url.includes("AuthenticateCond") ||
            url.includes(environment.apiMensajeria + "api/Login") ||
            url.includes("authenticatedevice") ||
            url.includes("vtc/api")
        ) {
            return next.handle(request);
        }
        const tokenMap = [
            { match: environment.apiMensajeria, token: currentUser.tokenMensajeria },
            { match: environment.apiTrafico, token: currentUser.tokenTrafico },
            { match: environment.apiTAD, token: currentUser.tokenTad },
            { match: environment.apiTaller, token: currentUser.tokenTaller },
        ];
        const found = tokenMap.find(x => url.includes(x.match));
        const token = found?.token;
        if (!token) {
            return next.handle(request);
        }
        const clonedRequest = request.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`,
            },
        });
        return next.handle(clonedRequest);
    }
}